export enum FilterTypes {
    ALL = 'all',
    COMPATIBLE = 'compatible',
    INCOMPATIBLE = 'incompatible'
}

export type UpdateQueueRequestBody = {
    DisableRTMonitoring: boolean
}

export const LINKAGE_TYPES_CALLQUEUE = 'callqueue' as const
export const LINKAGE_TYPES_AUTOATTENDANT = 'autoattendant' as const
export const LINKAGE_TYPES_POLICY = 'policy' as const

export const LINKAGE_EXCEPTION_TYPES_OVERFLOW = 'Overflow' as const
export const LINKAGE_EXCEPTION_TYPES_TIMEOUT = 'Timeout' as const
export const LINKAGE_EXCEPTION_TYPES_NOAGENT = 'NoAgent' as const
export const LINKAGE_EXCEPTION_TYPES_OBO = 'OBO' as const

export type CallQueueLinkageInfo = {
    type: typeof LINKAGE_TYPES_CALLQUEUE
    name: string
    exception:
        | typeof LINKAGE_EXCEPTION_TYPES_OVERFLOW
        | typeof LINKAGE_EXCEPTION_TYPES_TIMEOUT
        | typeof LINKAGE_EXCEPTION_TYPES_NOAGENT
        | typeof LINKAGE_EXCEPTION_TYPES_OBO
    callQueueId: string
    resourceAccountId: string
    resourceAccountUpn: string
}

export const LINKAGE_MENU_TYPES_BUSINESSHOURS = 'BusinessHours' as const
export const LINKAGE_MENU_TYPES_AFTERHOURS = 'AfterHours' as const
export const LINKAGE_MENU_TYPES_HOLIDAY = 'Holiday' as const

export type AutoAttendantLinkageInfo = {
    type: typeof LINKAGE_TYPES_AUTOATTENDANT
    name: string
    menu:
        | typeof LINKAGE_MENU_TYPES_BUSINESSHOURS
        | typeof LINKAGE_MENU_TYPES_AFTERHOURS
        | typeof LINKAGE_MENU_TYPES_HOLIDAY
    option: string
    autoAttendantId: string
    resourceAccountId: string
    resourceAccountUpn: string
}

export const LINKAGE_POLICY_TYPES_TEAMS_SHARED_CALLING_ROUTING_POLICY = 'TeamsSharedCallingRoutingPolicy' as const
export const LINKAGE_POLICY_TYPES_UNASSIGNED_NUMBER_TREATMENT = 'TeamsUnassignedNumberTreatment' as const
export const LINKAGE_POLICY_TYPES_CALLING_LINE_IDENTITY = 'CallingLineIdentity' as const

export type PolicyLinkageInfo = {
    type: typeof LINKAGE_TYPES_POLICY
    policyType:
        | typeof LINKAGE_POLICY_TYPES_TEAMS_SHARED_CALLING_ROUTING_POLICY
        | typeof LINKAGE_POLICY_TYPES_UNASSIGNED_NUMBER_TREATMENT
        | typeof LINKAGE_POLICY_TYPES_CALLING_LINE_IDENTITY
    policyId: string
    resourceAccountId: string
    resourceAccountUpn: string
}

export type VoiceAppLinkageInfo = CallQueueLinkageInfo | AutoAttendantLinkageInfo | PolicyLinkageInfo
